import { render, staticRenderFns } from "./problemAdd.vue?vue&type=template&id=42f71640&scoped=true&"
import script from "./problemAdd.vue?vue&type=script&lang=js&"
export * from "./problemAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f71640",
  null
  
)

export default component.exports